import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useRecoilState } from 'recoil';
import { calcBundleSizeInMB, fileBundleMatchSize, } from '@zurich/common/forms';
import { useTranslation } from '@zurich/common/hooks';
import { fileUploadSelectorFamily } from '@zurich/common/recoil';
import { styled } from '../../utils';
import { CardContent } from '../Card';
import { Typography } from '../Typography';
import { FileBundleError } from './FileBundleError';
import { FileInfo } from './FileInfo';
import { FileInfoError } from './FileInfoError';
export const FileUploadPreview = memo(({ id, disabled, bundleErrors, setBundleErrors, maxBundleSize, title, description, noPadding = false, }) => {
    const { t } = useTranslation();
    const [files, setFiles] = useRecoilState(fileUploadSelectorFamily(id));
    const handleDelete = (file) => {
        const bundleErrs = [];
        setFiles((cur) => {
            const tmpFiles = (cur || []).filter((item) => item.file !== file);
            // we have to check the bundle size error again
            if (tmpFiles && maxBundleSize !== undefined) {
                const { bundleSizeError } = fileBundleMatchSize(tmpFiles.map((f) => f.file), maxBundleSize, t);
                if (bundleSizeError) {
                    bundleErrs.push(bundleSizeError);
                }
            }
            return tmpFiles;
        });
        if (setBundleErrors) {
            setBundleErrors(bundleErrs);
        }
    };
    return (_jsx("div", { children: files && files.length > 0 ? (_jsxs(CardContent, { noPadding: noPadding, children: [title && (_jsxs(DivStyled, { children: [_jsx(Typography, { fontSize: "0.5rem", color: "primary", fontWeight: 600, children: title }), description && (_jsx(Typography, { fontSize: "1rem", variant: "body2", children: description })), _jsx(Typography, { fontSize: "1rem", variant: "body2", children: t('common:uploadSizeFromTo', {
                                mbCurrent: calcBundleSizeInMB(files.map((f) => f.file)),
                                mbMax: maxBundleSize,
                            }) })] })), files.map((file, index) => (_jsx(FileInfoRootStyled, { first: index === 0, last: files.length - 1 === index, children: file.errors.length > 0 ? (_jsx(FileInfoError, { file: file.file, onDelete: handleDelete, errors: file.errors })) : (_jsx(FileInfo, { file: file.file, onDelete: handleDelete, disabled: disabled })) }, index))), _jsx(FileBundleError, { bundleErrors: bundleErrors ?? [] })] })) : null }));
});
FileUploadPreview.displayName = 'FileUploadPreview';
const FileInfoRootStyled = styled('div')(({ theme, first, last }) => ({
    ...(!last && {
        paddingBottom: theme.spacing(1),
        borderBottom: `1px solid ${theme.palette.secondary.contrastText}`,
    }),
    ...(!first && {
        paddingTop: theme.spacing(1),
    }),
}));
const DivStyled = styled('div')(() => ({
    paddingBottom: '10px',
}));
